import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import withSound from '../../containers/withSounds';
import './RewardsButton.css';

function RewardsButton({ href, handleRoute, ...otherProps }) {
  return (
    <Link
      to={href}
      onClick={handleRoute}
      className="rewards-button btn btn-success"
      {...otherProps}
    >
      Rewards
    </Link>
  );
}

Link.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  onClick: PropTypes.func
};

export default withSound({ mouseEnterSound: true })(RewardsButton);



// WEBPACK FOOTER //
// ./src/components/RewardsButton/index.js